// Shared live region utility for announcing dynamic content changes to assistive technology
// Creates a single aria-live region in the DOM and provides functions to announce messages.
/* start-amd-strip-block */
(function(factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		module.exports = factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function($) {
	/* end-amd-strip-block */

	var POLITE_REGION_ID = 'civics-live-region-polite';
	var ASSERTIVE_REGION_ID = 'civics-live-region-assertive';
	var CLEAR_DELAY = 3000;

	function ensureRegion(id, politeness) {
		var $region = $('#' + id);
		if ($region.length === 0) {
			$region = $('<div>')
				.attr('id', id)
				.attr('aria-live', politeness)
				.attr('aria-atomic', 'true')
				.attr('role', 'status')
				.addClass('scr')
				.appendTo('body');
		}
		return $region;
	}

	function announce($region, message) {
		// Clear first to ensure re-announcement of identical messages
		$region.text('');
		setTimeout(function() {
			$region.text(message);
		}, 50);

		// Clear after delay so it doesn't accumulate
		setTimeout(function() {
			$region.text('');
		}, CLEAR_DELAY);
	}

	var LiveRegionUtility = {
		/**
		 * Announce a message politely (waits for current speech to finish).
		 * Use for: pagination, search results, content updates.
		 * @param {string} message - The message to announce
		 */
		announcePolite: function(message) {
			var $region = ensureRegion(POLITE_REGION_ID, 'polite');
			announce($region, message);
		},

		/**
		 * Announce a message assertively (interrupts current speech).
		 * Use for: urgent errors, critical alerts.
		 * @param {string} message - The message to announce
		 */
		announceAssertive: function(message) {
			var $region = ensureRegion(ASSERTIVE_REGION_ID, 'assertive');
			announce($region, message);
		}
	};

	// Expose as a jQuery utility
	$.civicsLiveRegion = LiveRegionUtility;

	return LiveRegionUtility;

	/* start-amd-strip-block */
}));
/* end-amd-strip-block */
